import React, { useState } from 'react';
import Values from 'values.js';
import SinglColor from './SinglColor';

function App() {
  const [color,setColor] = useState('');
  const [error,setError] = useState(false);
  const [list, setList] = useState(new Values('#F900FF').all(10));

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      let colors = new  Values(color).all(10);
      setList(colors);
    } catch (error) {
      setError(true)
      console.log(error)
      
    }
}
  return (
    <>
    <section className="container">
      <h2 className="text">Color Generator</h2>
      <form onSubmit= {handleSubmit} className="formm">
        <input 
        type="text" 
        value={color}
         onChange = {(e) => setColor(e.target.value)}
         placeholder='#F900FF'
         className={`${error? 'error' : null}`}
          />
         <button type="submit">Submit</button>
      </form>
    </section>
    <section className="colors">
        {list.map((color,index)=> {
          return <SinglColor key={index} 
          {...color} 
          index = {index}
          hexColor = {color.hex} />
        })}
    </section>
    </>
  );
}

export default App;
